import apiService from './apiService';

export default (function() {
	var servicePath = '/MediaShareText';
	var parseOptions = {
		'datetimes': ['createDate']
	};

	function create(record) {
		return apiService
			.post(JSON.stringify(record), servicePath)
			.done(function(data) {
				apiService.parse(data, parseOptions);
			});
	}

	function remove(id) {
		var url = servicePath + '/' + id;

		return apiService.delete(null, url);
	}

	// Get text by media id
	function fetch(mediaId) {
		if (mediaId) {
			const url = servicePath + '?media_id=' + mediaId;

			return apiService.get(url)
				.then(function(data) {
					return data.items;
				});
		}
	}

	function update(record) {
		return apiService.put(JSON.stringify(record), servicePath);
	}

	return {
		create: create,
		remove: remove,
		fetch: fetch,
		update: update
	};
})();